import React from "react";
import { useContext } from "react";
import { useCallback } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useAuth } from "../../../../auth/hooks/useAuth";
import { useQuery } from "react-query";
import useSchoolQueries from "../../../hooks/useSchoolQueries";
import Loading from "../../../../../components/Loading";

export const SchoolCardsContext = React.createContext<
  Partial<ReturnType<typeof useSchoolCardsProvider>>
>({});

export const SchoolCardsProvider: React.FC = ({ children }) => {
  const provider = useSchoolCardsProvider();

  if (provider.userFavorites.isLoading || provider.userFavorites.isFetching)
    return <Loading />;

  return (
    <SchoolCardsContext.Provider value={provider}>
      {children}
    </SchoolCardsContext.Provider>
  );
};

export const useSchoolCards = function () {
  return useContext(SchoolCardsContext);
};

export const useSchoolCardsProvider = function () {
  const [isLoading, setLoading] = useState<string[]>([]);
  const [favorites, setFavorites] = useState<string[]>([]);
  const { user } = useAuth();

  const {
    fetchMyFavorites,
    fetchMakeSchoolFavorite,
    fetchRemoveSchoolFavorite,
  } = useSchoolQueries();

  const userFavorites = useQuery<any>(
    `user_${user.id}_favorite_schools`,
    () => {
      if ([2, 4].includes(user.role)) return fetchMyFavorites();
    },
  );

  useEffect(() => {
    setFavorites(
      userFavorites.data ? userFavorites.data.data.map((item) => item.id) : [],
    );
  }, [userFavorites.data]);

  const toggleLoading = useCallback(
    (id: string) => {
      setLoading((isLoading) => {
        if (isLoading.includes(id))
          return isLoading.filter((item) => item !== id);
        else {
          return [...isLoading, id];
        }
      });
    },
    [user, isLoading, setLoading],
  ); // eslint-disable-line react-hooks/exhaustive-deps

  const toggleFavorite = useCallback(
    async (id: string) => {
      toggleLoading(id);
      if (favorites.includes(id)) {
        await fetchRemoveSchoolFavorite(id);
        setFavorites(favorites.filter((item) => item !== id));
      } else {
        await fetchMakeSchoolFavorite(id);
        setFavorites((items) => [...items, id]);
      }
      toggleLoading(id);
    },
    [user, favorites, isLoading], // eslint-disable-line react-hooks/exhaustive-deps
  );

  return {
    userFavorites,
    favorites,
    isLoading,
    toggleFavorite,
  };
};
